"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferencesDefinition = exports.GetOptions = exports.PublishResponse = exports.PublishRequest = exports.GetResponse = exports.GetRequest = exports.Reference = void 0;
/* eslint-disable */
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const items_1 = require("../items/items");
function createBaseReference() {
    return { id: "", collectionId: "", disabled: false };
}
exports.Reference = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.collectionId !== "") {
            writer.uint32(18).string(message.collectionId);
        }
        if (message.disabled === true) {
            writer.uint32(24).bool(message.disabled);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseReference();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.collectionId = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.disabled = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.Reference.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseReference();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.collectionId = (_b = object.collectionId) !== null && _b !== void 0 ? _b : "";
        message.disabled = (_c = object.disabled) !== null && _c !== void 0 ? _c : false;
        return message;
    },
};
function createBaseGetRequest() {
    return { spaceId: "", envId: "", references: [], options: undefined };
}
exports.GetRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spaceId !== "") {
            writer.uint32(10).string(message.spaceId);
        }
        if (message.envId !== "") {
            writer.uint32(18).string(message.envId);
        }
        for (const v of message.references) {
            exports.Reference.encode(v, writer.uint32(26).fork()).ldelim();
        }
        if (message.options !== undefined) {
            exports.GetOptions.encode(message.options, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spaceId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.envId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.references.push(exports.Reference.decode(reader, reader.uint32()));
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.options = exports.GetOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.GetRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseGetRequest();
        message.spaceId = (_a = object.spaceId) !== null && _a !== void 0 ? _a : "";
        message.envId = (_b = object.envId) !== null && _b !== void 0 ? _b : "";
        message.references = ((_c = object.references) === null || _c === void 0 ? void 0 : _c.map((e) => exports.Reference.fromPartial(e))) || [];
        message.options = (object.options !== undefined && object.options !== null)
            ? exports.GetOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBaseGetResponse() {
    return { items: [], notfound: [] };
}
exports.GetResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.items) {
            items_1.Item.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.notfound) {
            exports.Reference.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.items.push(items_1.Item.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.notfound.push(exports.Reference.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.GetResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseGetResponse();
        message.items = ((_a = object.items) === null || _a === void 0 ? void 0 : _a.map((e) => items_1.Item.fromPartial(e))) || [];
        message.notfound = ((_b = object.notfound) === null || _b === void 0 ? void 0 : _b.map((e) => exports.Reference.fromPartial(e))) || [];
        return message;
    },
};
function createBasePublishRequest() {
    return { spaceId: "", envId: "", references: [], recursive: false, force: false };
}
exports.PublishRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spaceId !== "") {
            writer.uint32(10).string(message.spaceId);
        }
        if (message.envId !== "") {
            writer.uint32(18).string(message.envId);
        }
        for (const v of message.references) {
            exports.Reference.encode(v, writer.uint32(26).fork()).ldelim();
        }
        if (message.recursive === true) {
            writer.uint32(32).bool(message.recursive);
        }
        if (message.force === true) {
            writer.uint32(40).bool(message.force);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePublishRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spaceId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.envId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.references.push(exports.Reference.decode(reader, reader.uint32()));
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.recursive = reader.bool();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.force = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.PublishRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBasePublishRequest();
        message.spaceId = (_a = object.spaceId) !== null && _a !== void 0 ? _a : "";
        message.envId = (_b = object.envId) !== null && _b !== void 0 ? _b : "";
        message.references = ((_c = object.references) === null || _c === void 0 ? void 0 : _c.map((e) => exports.Reference.fromPartial(e))) || [];
        message.recursive = (_d = object.recursive) !== null && _d !== void 0 ? _d : false;
        message.force = (_e = object.force) !== null && _e !== void 0 ? _e : false;
        return message;
    },
};
function createBasePublishResponse() {
    return { published: [], notfound: [], unpublished: [] };
}
exports.PublishResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.published) {
            exports.Reference.encode(v, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.notfound) {
            exports.Reference.encode(v, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.unpublished) {
            exports.Reference.encode(v, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePublishResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.published.push(exports.Reference.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.notfound.push(exports.Reference.decode(reader, reader.uint32()));
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.unpublished.push(exports.Reference.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.PublishResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBasePublishResponse();
        message.published = ((_a = object.published) === null || _a === void 0 ? void 0 : _a.map((e) => exports.Reference.fromPartial(e))) || [];
        message.notfound = ((_b = object.notfound) === null || _b === void 0 ? void 0 : _b.map((e) => exports.Reference.fromPartial(e))) || [];
        message.unpublished = ((_c = object.unpublished) === null || _c === void 0 ? void 0 : _c.map((e) => exports.Reference.fromPartial(e))) || [];
        return message;
    },
};
function createBaseGetOptions() {
    return { localeId: "", translationsIds: [] };
}
exports.GetOptions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.localeId !== "") {
            writer.uint32(10).string(message.localeId);
        }
        for (const v of message.translationsIds) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.localeId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.translationsIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.GetOptions.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseGetOptions();
        message.localeId = (_a = object.localeId) !== null && _a !== void 0 ? _a : "";
        message.translationsIds = ((_b = object.translationsIds) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        return message;
    },
};
exports.ReferencesDefinition = {
    name: "References",
    fullName: "content.references.References",
    methods: {
        /** Get возвращает список записей по ссылкам */
        get: {
            name: "Get",
            requestType: exports.GetRequest,
            requestStream: false,
            responseType: exports.GetResponse,
            responseStream: false,
            options: {},
        },
        /**
         * Publish принимает список ссылок на записи и публикует их с учетом вложенных ссылок.
         *
         * - В случае если флаг `recursive` установлен в true, то будут рекурсивно опубликованы
         *   все записи на которые ссылаются найденные записи.
         * - Если флаг `recursive` установлен в false, то будут опубликованы записи
         *   только из списка `references` в случае если они не содержат не опубликованных
         *   ссылок. В противном случае возвращается список не опубликованных записей `unpublished`
         *   которые требуют публикации. Список `published` при этом будет пустым. В случае если флаг
         *   `force` установлен в true, то записи будут опубликованы даже если они содержат
         *   не опубликованные ссылки.
         */
        publish: {
            name: "Publish",
            requestType: exports.PublishRequest,
            requestStream: false,
            responseType: exports.PublishResponse,
            responseStream: false,
            options: {},
        },
    },
};
//# sourceMappingURL=references.js.map